import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable camelcase */
import React, { useRef, useState, useEffect } from 'react';
import { Row, Col, Table, Dropdown, useIsMounted, useUser, showSuccess } from 'components';
import { showApiError } from 'utils';
import { getAllPastCommissionReports, getAllPartners, acceptCommissionReport } from 'services';
import { allPastReportsColumns } from './config';
import { tableHeaderContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var AllPastReportsTab = function AllPastReportsTab() {
  var tableRef = useRef();
  var isMounted = useIsMounted();
  var queryParams = useRef({});

  var _useUser = useUser(),
      roleAdditionalData = _useUser.roleAdditionalData;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      partners = _useState2[0],
      setPartners = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedPartner = _useState4[0],
      setSelectedPartner = _useState4[1];

  useEffect(function () {
    fetchPartners();
  }, []);
  useEffect(function () {
    if (isMounted.current) {
      var _tableRef$current;

      queryParams.current = {
        partner: selectedPartner
      };
      (_tableRef$current = tableRef.current) === null || _tableRef$current === void 0 ? void 0 : _tableRef$current.getData(queryParams.current);
    }
  }, [selectedPartner]);

  var fetchPartners = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getAllPartners, _yield$getAllPartners2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAllPartners();

            case 2:
              _yield$getAllPartners = _context.sent;
              _yield$getAllPartners2 = _slicedToArray(_yield$getAllPartners, 2);
              res = _yield$getAllPartners2[0];
              err = _yield$getAllPartners2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setPartners(res);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchPartners() {
      return _ref.apply(this, arguments);
    };
  }();

  var fetchAllPastReports = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(tableOptions) {
      var _yield$getAllPastComm, _yield$getAllPastComm2, res, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getAllPastCommissionReports(tableOptions);

            case 2:
              _yield$getAllPastComm = _context2.sent;
              _yield$getAllPastComm2 = _slicedToArray(_yield$getAllPastComm, 2);
              res = _yield$getAllPastComm2[0];
              err = _yield$getAllPastComm2[1];

              if (!err) {
                _context2.next = 9;
                break;
              }

              showApiError(err);
              return _context2.abrupt("return", [null, err]);

            case 9:
              return _context2.abrupt("return", [res, null]);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchAllPastReports(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleAccept = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(reportId) {
      var _tableRef$current2;

      var _yield$acceptCommissi, _yield$acceptCommissi2, err;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return acceptCommissionReport(reportId);

            case 2:
              _yield$acceptCommissi = _context3.sent;
              _yield$acceptCommissi2 = _slicedToArray(_yield$acceptCommissi, 2);
              err = _yield$acceptCommissi2[1];

              if (!err) {
                _context3.next = 7;
                break;
              }

              return _context3.abrupt("return", showApiError(err));

            case 7:
              showSuccess('Отчетът е приет успешно!');
              (_tableRef$current2 = tableRef.current) === null || _tableRef$current2 === void 0 ? void 0 : _tableRef$current2.getData(queryParams.current);

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleAccept(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var filterBar = function filterBar() {
    return ___EmotionJSX("section", {
      css: tableHeaderContainer
    }, ___EmotionJSX(Row, {
      horizontalGap: 16,
      verticalGap: 8
    }, ___EmotionJSX(Col, {
      sm: 12,
      md: 3
    }, ___EmotionJSX(Dropdown, {
      small: true,
      withSearch: true,
      placeholder: "\u041F\u0430\u0440\u0442\u043D\u044C\u043E\u0440",
      displayKey: "name",
      uniqueKey: "id",
      value: selectedPartner,
      options: partners,
      onChange: setSelectedPartner,
      mapValue: function mapValue(val) {
        return val === null || val === void 0 ? void 0 : val.id;
      }
    }))));
  };

  return ___EmotionJSX(Table, {
    hasPagination: true,
    ref: tableRef,
    getDataMethod: fetchAllPastReports,
    columns: allPastReportsColumns({
      isAdminOrTenant: roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.isAdminOrTenant,
      onAccept: handleAccept
    }),
    emptyMessage: "\u041D\u044F\u043C\u0430 \u043C\u0438\u043D\u0430\u043B\u0438 \u043E\u0442\u0447\u0435\u0442\u0438",
    filterBar: filterBar,
    margin: "0 2em",
    pageSize: 20
  });
};

export default AllPastReportsTab;